// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep angular-phone-number-input div.wrap {
  border: none;
  border-radius: 8px;
  padding: 10px 15px;
  font-family: "Cairo", sans-serif;
  font-size: 14px;
  font-weight: 300;
  outline: none;
  transition: border 0.3s ease;
  width: 100%;
  height: 45px !important;
}
:host ::ng-deep angular-phone-number-input div.wrap > .flex:first-child {
  position: relative;
  padding-right: 12px;
  margin-right: 12px;
}
:host ::ng-deep angular-phone-number-input div.wrap > .flex:first-child::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 60%;
  width: 1px;
  background-color: #ddd;
}

::ng-deep .modal-wrap {
  z-index: 100;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/phone-component/phone-component.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,uBAAA;AACJ;AACI;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;AACR;AACQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;AACZ;;AAIA;EACI,YAAA;AADJ","sourcesContent":[":host ::ng-deep angular-phone-number-input div.wrap {\n    border: none;\n    border-radius: 8px;\n    padding: 10px 15px;\n    font-family: 'Cairo', sans-serif;\n    font-size: 14px;\n    font-weight: 300;\n    outline: none;\n    transition: border 0.3s ease;\n    width: 100%;\n    height: 45px !important;\n\n    >.flex:first-child {\n        position: relative;\n        padding-right: 12px;\n        margin-right: 12px;\n\n        &::after {\n            content: '';\n            position: absolute;\n            right: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            height: 60%;\n            width: 1px;\n            background-color: #ddd;\n        }\n    }\n}\n\n::ng-deep .modal-wrap {\n    z-index: 100;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
